import React from "react";
import { Button, Modal } from "react-bootstrap";
import { NoAction } from "../../ui/icons";
import useNoActionPopup from "./useNoActionPopup";

const NoActionPopup = () => {
  const { handleClose, show, message } = useNoActionPopup();

  return (
    <Modal
      show={show}
      onHide={handleClose}
      className="modal-container editdevicename-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="delete-heading">
            <NoAction></NoAction>
            <h1>This action cannot be done</h1>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {message || "It is not possible to delete a group if there are devices or groups or users assigned to this group"}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-style" onClick={handleClose}>
          Okay
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NoActionPopup;
